export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9301.00b153b6.jpg";